import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "full-width section-small bg-gray-light mt-2 mb-4 my-md-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "support-videos-app__filtering row" }
const _hoisted_4 = { class: "support-videos-app__filtering-col col-md-12 col-lg-3" }
const _hoisted_5 = { class: "support-videos-app__filter-head" }
const _hoisted_6 = { class: "support-videos-app__filtering-col col-md-4 col-lg-3" }
const _hoisted_7 = { class: "support-videos-app__filtering-col col-md-4 col-lg-3" }
const _hoisted_8 = { class: "support-videos-app__filtering-col col-md-4 col-lg-3" }
const _hoisted_9 = { class: "support-videos-app__container" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "support-videos-app__list"
}
const _hoisted_12 = {
  key: 0,
  class: "text-center section-small-md-up"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "load-indicator__indicator" }, null, -1 /* HOISTED */)
const _hoisted_14 = { class: "load-indicator__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SupportVideoFilter = _resolveComponent("SupportVideoFilter")!
  const _component_SupportVideoCard = _resolveComponent("SupportVideoCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString($data.translations?.FilterBy), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_SupportVideoFilter, {
              filter: "Portfolio",
              filterOptions: $data.filterPortfoliosData,
              onFilterChange: $options.filterChange
            }, {
              filterTitle: _withCtx(() => [
                _createTextVNode(_toDisplayString($data.translations?.Portfolio), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["filterOptions", "onFilterChange"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_SupportVideoFilter, {
              filter: "ProductType",
              filterOptions: $data.filterProductTypesData,
              onFilterChange: $options.filterChange
            }, {
              filterTitle: _withCtx(() => [
                _createTextVNode(_toDisplayString($data.translations?.ProductType), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["filterOptions", "onFilterChange"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_SupportVideoFilter, {
              filter: "Topics",
              filterOptions: $data.filterTopicsData,
              onFilterChange: $options.filterChange
            }, {
              filterTitle: _withCtx(() => [
                _createTextVNode(_toDisplayString($data.translations?.Topics), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["filterOptions", "onFilterChange"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      ($data.supportVideos && $data.supportVideos.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($data.translations?.NoMatchingSupportVideos), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("ul", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.supportVideos, (supportVideo) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "support-videos-app__item",
                key: supportVideo.Id
              }, [
                _createVNode(_component_SupportVideoCard, {
                  title: supportVideo.Title,
                  youtubeID: supportVideo.YouTubeID,
                  thumbnail: supportVideo.Thumbnail,
                  thumbnailImageUrl: supportVideo.ThumbnailImageUrl,
                  urlName: supportVideo.UrlName,
                  id: supportVideo.Id,
                  portfolio: supportVideo.Portfolio.PersistedValue,
                  productType: supportVideo.ProductType.Text,
                  topic: supportVideo.Topic.Text,
                  stepId: supportVideo.StepId,
                  videoDescription: supportVideo.VideoDescription
                }, null, 8 /* PROPS */, ["title", "youtubeID", "thumbnail", "thumbnailImageUrl", "urlName", "id", "portfolio", "productType", "topic", "stepId", "videoDescription"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
    ]),
    ($data.buttonEnabled === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.showAllTrigger && $options.showAllTrigger(...args))),
            class: "btn btn-primary btn-lg"
          }, _toDisplayString($data.translations?.ShowMore), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["load-indicator", { 'state-visible': $data.loadingResults === true }])
    }, [
      _hoisted_13,
      _createElementVNode("span", _hoisted_14, _toDisplayString($data.translations?.Loading), 1 /* TEXT */)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["load-indicator-cover", { 'state-visible': $data.loadingResults === true }])
    }, null, 2 /* CLASS */)
  ]))
}